module.exports = __webpack_public_path__ + "static/media/wsp_logo.35b8232a.svg";